import { useParams } from 'react-router-dom';

import AuditHistoryAccordion from './AuditHistoryAccordion';
import Layout from './Layout';
import { useGetIncomeCalculatorAuditHistory } from './hooks';

export default function IncomeCalculatorAuditHistory() {
  const { customerRecordId, employerId, calculatorTypeId } = useParams<{
    customerRecordId: string;
    employerId: string;
    calculatorTypeId: string;
  }>();

  const {
    data: auditHistory,
    isLoading,
    isError,
  } = useGetIncomeCalculatorAuditHistory(
    Number.parseInt(customerRecordId),
    Number.parseInt(employerId),
    calculatorTypeId,
  );

  return (
    <Layout
      pageEnum={'INCOME'}
      isLoading={isLoading}
      isError={isError}
      isDataEmpty={!auditHistory?.length}
    >
      <AuditHistoryAccordion data={auditHistory} />
    </Layout>
  );
}
